<template>
  <div class="pd container mx-auto">

    <ul class="pd__ls row">
      <ProdItem v-for="item, index in resp" :key="index" :item="item" />
    </ul>
  </div>
</template>

<script>
import ProdItem from './ProdItem';

export default {
  data() {
    return {
      resp: [
        {
          name: 'MacBook Pro 16 灰',
          desc: '8核心第九代 i9 / 1TB / 2.4GHz',
          src: 'https://b.ecimg.tw/items/DYAJBGA900AIFEX/000001_1588847796.jpg',
          price: 110900,
        },
        {
          name: 'Apple Watch S6',
          desc: '藍色鋁金屬錶殼海軍深藍色運動型錶帶',
          src: 'https://b.ecimg.tw/items/DYAJCLA900AVOGK/000001_1600407932.jpg',
          price: 12900,
        },
        {
          name: 'Mac mini 3.6GHz',
          desc: '第八代 i3 / 8GB / 256GB',
          src: 'https://b.ecimg.tw/items/DYAJER1900AP0HX/000001_1591153062.jpg',
          price: 23828,
        },
        {
          name: 'MacBook Air 13 金色',
          desc: '256GB / 雙核心第10代 i3 / 1.1GHz',
          src: 'https://c.ecimg.tw/items/DYAJEX1900AOLWE/000001_1590548767.jpg',
          price: 29900,
        },
      ],
    }
  },
  components: {
    ProdItem,
  },
}
</script>

<style>
.pd__ls {
  display: flex;
  list-style-type: none;
  padding-left: 0;
}

.pd__item {
  padding: 10px;
}

.pd .gutter {
  height: 100%;
  padding: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  border: solid 1px #ddd;
}

.pd__head, .pd__foot {
  text-align: center;
}

.pd__name {
  margin: 0;
}

.pd__price {
  margin: 0;
  font-size: 45px;
  font-weight: 600;
  color: #ff007c;
}
</style>



// WEBPACK FOOTER //
// src/components/Prod/ProdContainer.vue